import React, {useContext} from 'react';
import {AppCtx} from "../../../AppCtx";
import {RiExpandHeightLine} from 'react-icons/ri';

/** @deprecated Hidden from the simplified catalogue menu. */
export default () => {
  const {isSongExpanded, setIsSongExpanded} = useContext(AppCtx);
  return <div style={{cursor:'pointer',position:'relative'}} 
              onClick={()=>setIsSongExpanded(!isSongExpanded)}
              role="button" tabIndex={0}
              aria-label={isSongExpanded ? "Zwiń piosenkę" : "Rozwiń piosenkę"}
              title={isSongExpanded ? "Zwiń piosenkę" : "Rozwiń piosenkę"}>
    <RiExpandHeightLine style={{color:isSongExpanded?'var(--menu-icon-color)':'var(--menu-icon-inactive-color)'}}/>
  </div>;
};
